import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,

  stats: {
    total_inquiries: 0,
    pending: 0,
    in_progress: 0,
    working: 0,
  },

  companies: [],
  total: 0,
  page: 1,
  limit: 10,

  deletingId: null,
  deleteError: null,
  deleteSuccessMessage: null,

  feedbackLoading: false,
  feedbackError: null,
  feedbackData: null, // { company_id, feedback } from GET
  feedbackSubmitting: false,
  feedbackSubmitError: null,
  feedbackSubmitSuccess: null,

  // export
  exportLoading: false,
  exportError: null,
  exportSuccess: false,
};

const superAdminDashboardSlice = createSlice({
  name: 'superAdminDashboard',
  initialState,
  reducers: {
    fetchDashboardRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchDashboardSuccess: (state, action) => {
      state.loading = false;

      const data = action.payload || {};
      const companies = data.companies ?? data.list ?? [];

      state.stats = {
        total_inquiries: data.total_inquiries ?? 0,
        pending: data.pending ?? 0,
        in_progress: data.in_progress ?? 0,
        working: data.working ?? 0,
      };

      state.companies = Array.isArray(companies) ? companies : [];
      state.total = data.total ?? data.total_count ?? data.totalRows ?? state.companies.length ?? 0;
      state.page = data.page ?? state.page;
      state.limit = data.limit ?? state.limit;
    },

    fetchDashboardFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteVerificationRequest: (state, action) => {
      state.deletingId = action.payload;
      state.deleteError = null;
    },

    deleteVerificationSuccess: (state, action) => {
      state.deletingId = null;
      state.deleteError = null;
      state.deleteSuccessMessage = action.payload ?? 'Deleted successfully';
    },

    deleteVerificationFailure: (state, action) => {
      state.deletingId = null;
      state.deleteError = action.payload;
    },

    clearDeleteError: (state) => {
      state.deleteError = null;
    },

    clearDeleteSuccessMessage: (state) => {
      state.deleteSuccessMessage = null;
    },

    // Feedback
    fetchFeedbackRequest: (state) => {
      state.feedbackLoading = true;
      state.feedbackError = null;
      state.feedbackData = null;
    },
    fetchFeedbackSuccess: (state, action) => {
      state.feedbackLoading = false;
      state.feedbackData = action.payload;
    },
    fetchFeedbackFailure: (state, action) => {
      state.feedbackLoading = false;
      state.feedbackError = action.payload;
    },

    submitFeedbackRequest: (state) => {
      state.feedbackSubmitting = true;
      state.feedbackSubmitError = null;
      state.feedbackSubmitSuccess = null;
    },
    submitFeedbackSuccess: (state, action) => {
      state.feedbackSubmitting = false;
      state.feedbackSubmitSuccess = action.payload;
    },
    submitFeedbackFailure: (state, action) => {
      state.feedbackSubmitting = false;
      state.feedbackSubmitError = action.payload;
    },

    clearFeedbackState: (state) => {
      state.feedbackLoading = false;
      state.feedbackError = null;
      state.feedbackData = null;
      state.feedbackSubmitting = false;
      state.feedbackSubmitError = null;
      state.feedbackSubmitSuccess = null;
    },

    // export report
    downloadCsvRequest: (state) => {
      state.exportLoading = true;
      state.exportError = null;
      state.exportSuccess = false;
    },
    downloadCsvSuccess: (state) => {
      state.exportLoading = false;
      state.exportSuccess = true;
    },
    downloadCsvFailure: (state, action) => {
      state.exportLoading = false;
      state.exportError = action.payload;
      state.exportSuccess = false;
    },
  },
});

export const {
  fetchDashboardRequest,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  deleteVerificationRequest,
  deleteVerificationSuccess,
  deleteVerificationFailure,
  clearDeleteError,
  clearDeleteSuccessMessage,
  fetchFeedbackRequest,
  fetchFeedbackSuccess,
  fetchFeedbackFailure,
  submitFeedbackRequest,
  submitFeedbackSuccess,
  submitFeedbackFailure,
  clearFeedbackState,
  downloadCsvRequest,
  downloadCsvSuccess,
  downloadCsvFailure,
} = superAdminDashboardSlice.actions;

export default superAdminDashboardSlice.reducer;
